import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js';
import DataTableLayer from '../../components/DataTableLayer'
import PostByAgg from '../../utils/axios';
import DetailTrackRelease from './DetailTrackRelease';
import Modal from '../../components/Modal';
import ModalAlert from '../../components/ModalAlert';
import { useAuth } from '../../context/AuthContext';

const ReleaseApprovalForm = ({data,mode,onClose,onSubmit, open, previewImage}) => {


    const [formData,setFormData] = useState({
            music_label_code: "",
            music_label_name: "",
            status_code: "",
            status_name: "",
            release_type_name: "",
            genre_code: "",
            genre_name: "",
            sub_genre_code: "",
            sub_genre_name: "",
            release_code: "",
            title: "",
            sub_title: "",
            release_date: "",
            i_inline: "",
            c_inline: "",
            created_at: "",
            created_by: ""
    })
    // const [isThumbnail, setIsThumbnail] = useState(true);
    const [detailRelease,setDetailRelease] = useState([])
    const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: 0,
            totalRecords: 0,
            totalPages: 0,
    })
    const [openDetailRelease,setOpenDetailRelease] = useState(false)
    const [selectedRowViewDetail,setSelectedRowViewDetail] = useState({})
    const [openModalApproval,setOpenModalApproval] = useState(false)
    const [selectedRow,setSelectedRow] = useState()
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedRowApproval,setSelectedRowApproval] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [description, setDescription] = useState('');
    const {email} = useAuth();
    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        let year = date.getFullYear();

        if (year === 1) {
            year = 1000; // Ubah tahun menjadi 1000 jika tahun adalah 1
        }
    
        return `${day}-${month}-${year}`;
    }

    useEffect(() => {
        if (data) {
            const releaseList = data.original || data;
            setFormData({
                music_label_code: releaseList.music_label_code,
                music_label_name: releaseList.music_label_name,
                status_code: releaseList.status_code,
                status_name: releaseList.status_name,
                release_type_name: releaseList.release_type_name,
                genre_code: releaseList.genre_code,
                genre_name: releaseList.genre_name,
                sub_genre_code: releaseList.sub_genre_code,
                sub_genre_name: releaseList.sub_genre_name,
                release_code: releaseList.release_code,
                title: releaseList.title,
                sub_title: releaseList.sub_title,
                release_date: releaseList.release_date ? formatDate(releaseList.release_date) : "",
                created_at: releaseList.created_at,
                created_by: releaseList.created_by,
            })
        }
    },[data])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
          onSubmit(formData);
        }
      };
    
      const handleClose = () => {
        console.log("Modal closed");
        if (onClose) {
          onClose();
        }
      };

      const isReadOnly = mode === 'view';

      const columns =[
          {
            header: 'Title',
            accessorKey: 'title',
          },
          {
            header: 'Sub Title',
            accessorKey: 'sub_title',
          },
          {
            header: 'Inline',
            accessorKey: 'i_inline',
          },
          {
            header: 'Production Year',
            accessorKey: 'production_year',
          },
          {
            header: 'Maker',
            accessorKey: 'maker',
          },
          {
            header: 'ISRC',
            accessorKey: 'isrc',
          },
          {
            header: 'Catalog Number',
            accessorKey: 'catalog_number',
          },
          {
            header: 'Preview Start',
            accessorKey: 'preview_start',
            // cell: ({ row }) => {
            //     const formattedDate = formatDate(row.original.preview_start);
            //     return <span>{formattedDate}</span>;
            // },
          },
          {
            header:'Channels',
            accessorKey:'song_channels',
            cell: ({ row }) => {
              const songChannels = row.original.song_channels;
              
              if (songChannels && songChannels.length > 0) {
                // Menambahkan key unik untuk setiap item dalam map
                const channelNames = songChannels.map((channel, index) => (
                  <span key={`${index}_${channel.channel_name}`} className='badge bg-primary m-1'>
                    {channel.channel_name}
                  </span>
                ));
                return <div>{channelNames}</div>;
              }
              return <span>-</span>;  // Jika tidak ada data channel
            },
          },
          {
            header: "Status",
            cell: ({ row }) => {
              const songChannels = row.original.song_channels;
              
              // Function to return the badge color based on status
              const getStatusBadgeColor = (status) => {
                switch (status) {
                  case "WAITING":
                    return "bg-warning";  // Kuning
                  case "UPLOAD":
                    return "bg-primary";  // Biru
                  case "LIVE":
                    return "bg-success";  // Hijau
                  default:
                    return "bg-secondary"; // Warna default jika status tidak ditemukan
                }
              };
        
              if (songChannels && songChannels.length > 0) {
                const statusNames = songChannels.map((channel, index) => {
                  const badgeColor = getStatusBadgeColor(channel.status_name); // Ambil warna berdasarkan status
                  
                  return (
                    <span key={`${index}_${channel.status_name}`} className={`badge ${badgeColor} m-1 cursor-pointer`}>
                      {channel.status_name}
                    </span>
                  );
                });
                return <div onClick={() => handleApproval(row)}>{statusNames}</div>;
              }
        
              return <span>-</span>;
            },
          },
          {
            header: 'Lyric',
            accessorKey: 'lyric',
          },
          {
            header: 'Action',
            accessorKey: 'action',
            cell:({row})=>{
                return <button className="btn btn-warning btn-sm cursor-pointer" onClick={() => handleDetails(row)}>Details</button>
            }
          },
      ]

      const listStatus = [
        {
            value: "ST2505088414539",
            label: "Uploaded"
        },
       
    ]


      const handleApproval = (row) => {
          if (row && row.original) {
              console.log("Approval")
              console.log("ROW: ", row.original.song_channels.map((channel) => channel.song_channel_code))
              setSelectedRowApproval(row.original);
              setOpenModalApproval(true);
              setDescription('');
          } else {
              console.error("Invalid row data", row);
          }
    
        }
      
            const handleCloseModalApproval = () => {
              setOpenModalApproval(false);
              setSelectedStatus(null);
              setSelectedRowApproval('');
              setDescription('');
              GetDetailReleaseTrackList();
            }
      
            const handleSubmitApproval = () => {
              console.log("dor")
              const url = 'song/v1/track-channel/update-status'
              const songChannelCodes = selectedRowApproval.song_channels.map((channel) => channel.song_channel_code);
              PostByAgg({
                  url: url,
                  body:{
                      "song_channel_code" : songChannelCodes[0],
                      "status_code" : selectedStatus, 
                      "updated_by" : email
                  },
                  onResponse: onResponseStatusApproval,
                  onError: onErrorStatusApproval,
              })
            }
      
            const onResponseStatusApproval = (response) => {
              console.log("status Approval Response",response.data)
              if(response.data.code === "2002000"){
                  setShowSuccessModal(
                      <ModalAlert
                          show={true}
                          type={"success"}
                          message={`Approval ` + response.data.message.id}
                          action={() => {
                              setShowSuccessModal(false);
                              handleCloseModalApproval();
                              GetDetailReleaseTrackList();
                          }}
                      />
                  )
              }
            }
            
            const onErrorStatusApproval = (error) => {
              console.log("status Approval Error",error)
              setShowSuccessModal(
                  <ModalAlert
                      show={true}
                      type= {'failed'}
                      message={error.response.data.message.id}
                      action={() => {
                          handleCloseModalApproval();
                          GetDetailReleaseTrackList();
                      }}
                  />
              )
            }

      const GetDetailReleaseTrackList = () => {
              const url = 'song/v1/track/list'
              const releaseCode = data.original.release_code
              PostByAgg({
                  url: url,
                  body: {
                      "page_size":pagination.totalRecords,
                      "page":pagination.pageIndex + 1,
                      "release_code":releaseCode
                  },
                  onResponse: onResponseDetailTrackList,
                  onError: onErrorDetailTrackList
              })
            }
      
            function onResponseDetailTrackList(response) {
              console.log("response detailtrack",response.data)
              if(response.data.data && response.data.data.data.length > 0){
                  const totalRecords = response.data.data.total_records;
                  const totalPages = Math.ceil(totalRecords / pagination.pageSize);
                  setPagination((prev) => ({
                      ...prev,
                      totalRecords: totalRecords,
                      totalPages: totalPages,
                      pageSize: totalRecords,
                      // pageIndex: 0,
                  }));
                  setDetailRelease(response.data.data.data)
                 }else{
                    setDetailRelease([])
                 } 
            }
      
            function onErrorDetailTrackList(err) {
              console.log(err)
            }

      const handleDetails = (row) => {
        console.log("dortap")
        console.log(row.original)
        setOpenDetailRelease(true)
        setSelectedRowViewDetail(row)
      }

      const handleCloseDetailTrackRelease = () => {
        setOpenDetailRelease(false);
        setSelectedRowViewDetail('')
      };

      useEffect(() => {
        GetDetailReleaseTrackList()
      }, [pagination.pageIndex, pagination.pageSize])



  return (
      <div
          className={`modal fade ${open ? "show" : ""}`}
          tabIndex="-1"
          style={{ display: open ? "block" : "none" }}
          aria-hidden={!open}
      >
          <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                  <div className="modal-header justify-content-between">
                      <h5 className="modal-title">{mode === 'create' ? 'Create List Release Music' : 'View List Release Music'}</h5>
                      <button type="button" className="close" onClick={handleClose}>
                          <Icon icon="mdi:close-circle" width={24} height={24} />
                      </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                      {[
                          { label: 'Music Label Name', name: 'music_label_name' },
                          { label: 'Status', name: 'status_name'},
                          { label: 'Judul Release', name: 'title' },
                          { label: 'Sub Title', name: 'sub_title' },
                          { label: 'Release Type', name: 'release_type_name' },
                          { label: 'Genre', name: 'genre_name' },
                          { label: 'Sub Genre', name: 'sub_genre_name' },
                          { label: 'Release Date', name: 'release_date' },
                          { label: 'Created At', name: 'created_at' },
                          { label: 'Created By', name: 'created_by' },
                      ].map(({ label, name }) => (
                          <div className="col-md-6 mb-3" key={name}>
                            <label className="col-form-label" htmlFor={name}>
                                {label}:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id={name}
                                name={name}
                                value={formData[name]}
                                readOnly={isReadOnly}
                            />
                          </div>
                      ))}
                      </div>
                        <div className="col-md-12 mb-3">                
                            <DataTableLayer
                                data={detailRelease}
                                pagination={pagination}
                                columns={columns} 
                                title={"Track List"}  
                                onClick={() => {}} 
                                showButton={false}
                                />
                        </div>
                      {
                        openDetailRelease && (
                            <div className="col-md-12 mb-3">
                                <DetailTrackRelease
                                    data={selectedRowViewDetail}
                                    open={openDetailRelease}
                                    mode="detail"
                                    onClose={handleCloseDetailTrackRelease}
                                    onSubmit={()=>{}}
                                />
                            </div>
                        )
                      }
                      <div className="d-flex justify-content-end gap-2 mt-3">
                          {!isReadOnly && (
                          <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                              {mode === 'create' ? 'Create' : 'Submit'}
                          </button>
                          )}
                          <button type="button" className="btn btn-secondary" onClick={handleClose}>
                          Close
                          </button>
                      </div>
                    </form> 
                    {
                                    openModalApproval && (
                                        <Modal
                                          open={openModalApproval}
                                          onClose={handleCloseModalApproval}
                                          title={selectedRowApproval.music_label_name}
                                          Submit={handleSubmitApproval}
                                        >
                                            <div className="mb-3">
                                                <label className="col-form-label" htmlFor="status">Status :</label>
                                                <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} >
                                                    <option>Pilih </option>
                                                    {listStatus.map((status, index) => {
                                                        if (status.label !== selectedRowApproval.status_name) { 
                                                            return (
                                                                <option key={index} value={status.value}>
                                                                    {status.label}
                                                                </option>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </select>
                                               
                                                {
                                                    selectedStatus === "ST2505088414539" ? (
                                                    <div className="mb-3">
                                                        {/* <label className="col-form-label" htmlFor="isActive">Is Active :</label>
                                                        <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedActive(JSON.parse(e.target.value))} >
                                                            <option>Pilih </option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </select> */}
                                                    </div>
                                                    ):(
                                                    selectedStatus != null && (
                                                    <div className="mb-3">
                                                        {/* <label htmlFor="message-text" className="col-form-label">Message:</label>
                                                        <textarea className="form-control" id="message-text" defaultValue={description} onChange={(e) => setDescription(e.target.value)} cols={"30"} rows={"5"}></textarea> */}
                                                    </div>
                                                    )
                                                    )
                                                }
                                            </div>
                                        </Modal>
                                 )}
                  </div>
              </div>
              {showSuccessModal}
          </div>
      </div>
    );
}

export default ReleaseApprovalForm